import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-foreground/60 text-sm">
        Yükleniyor...
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}
